var React = require('react');

function ArrowLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#8DC8E8","fillRule":"evenodd","d":"M47.45 12H.5c-.275 0-.5-.427-.5-.95 0-.521.225-.948.5-.948h47.062l-8.731-7.859c-.991-.892.347-2.378 1.338-1.486l10 9c.427.384.422.878.198 1.245a1 1 0 0 1-.198 1.241l-10 9a1 1 0 1 1-1.338-1.486L47.45 12z"}));
}

ArrowLong.displayName = "ArrowLong";

ArrowLong.defaultProps = {"width":"51","height":"22"};

module.exports = ArrowLong;

ArrowLong.default = ArrowLong;



// WEBPACK FOOTER //
// ./src/images/icons/arrow-long.svg